<script setup lang="ts">
import { computed, ref } from "vue";

const a = ref(5);
const b = ref(3);

const returnedValue = computed(() => Number(a.value) + Number(b.value));
const printOutput = computed(() => `Screen par: ${returnedValue.value}`);
const returnOutput = computed(() => `Variable mein save: ${returnedValue.value}`);
</script>

<template>
  <section class="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900">print aur return ka farq</h2>
      <p class="text-sm text-slate-600">Yahan aasani se dekho ke kaun si cheez screen par dikhati hai aur kaun si value wapas bhejti hai.</p>
    </div>

    <div class="mt-4 grid grid-cols-2 gap-3">
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">a</span>
        <input v-model="a" type="number" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
      </label>
      <label class="space-y-2">
        <span class="text-sm font-medium text-slate-700">b</span>
        <input v-model="b" type="number" class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm">
      </label>
    </div>

    <pre class="mt-4 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-xs leading-6 text-slate-100"><code>def add(a, b):
    return a + b

result = add({{ a }}, {{ b }})</code></pre>

    <div class="mt-4 grid gap-3 sm:grid-cols-2">
      <div class="rounded-2xl bg-sky-50 p-4 ring-1 ring-sky-100">
        <p class="text-xs font-semibold uppercase tracking-wide text-sky-700">print</p>
        <p class="mt-2 text-sm text-slate-700">{{ printOutput }}</p>
      </div>
      <div class="rounded-2xl bg-emerald-50 p-4 ring-1 ring-emerald-100">
        <p class="text-xs font-semibold uppercase tracking-wide text-emerald-700">return</p>
        <p class="mt-2 text-sm text-slate-700">{{ returnOutput }}</p>
      </div>
    </div>
  </section>
</template>
